import { Col, Container, Row } from "react-bootstrap";

const SocialLinks = ({ align = "left", text = "true" }) => {
  const alignmentClass =
    align === "center" ? "justify-content-center" : "justify-content-start";
  const textClass = text === "true" ? "" : "text-hide";

  return (
    <Container className="social-links">
      <Row className={`${alignmentClass} ${textClass}`}>
        <Col xs="auto">
          <a
            href="https://facebook.com/scripthive"
            target="_blank"
            rel="noopener noreferrer"
            title="Join Script Hive on Facebook"
          >
            <i className="bi bi-facebook me-2"></i>
            <span className="socialLinkText">Facebook</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="https://scripthive.substack.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="Join Script Hive on Substack"
          >
            <i className="bi bi-substack me-2"></i>
            <span className="socialLinkText">Substack</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="https://bsky.app/profile/scripthive.bsky.social"
            target="_blank"
            rel="noopener noreferrer"
            title="Join Script Hive on Bluesky"
          >
            <i className="bi bi-bluesky me-2"></i>
            {/* TODO Hi */}
            <span className="socialLinkText">Bluesky</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="https://instagram.com/scripthive"
            target="_blank"
            rel="noopener noreferrer"
            title="Join Script Hive on Instagram"
          >
            <i className="bi bi-instagram me-2"></i>
            <span className="socialLinkText">Instagram</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="https://discord.gg/screenwriting"
            target="_blank"
            rel="noopener noreferrer"
            title="Join Script Hive on Discord"
          >
            <i className="bi bi-discord me-2"></i>
            <span className="socialLinkText">Discord</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="https://twitter.com/scripthive"
            target="_blank"
            rel="noopener noreferrer"
            title="Join Script Hive on X"
          >
            <i className="bi bi-twitter-x me-2"></i>
            <span className="socialLinkText">X</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="https://www.threads.com/@scripthive"
            target="_blank"
            rel="noopener noreferrer"
            title="Join Script Hive on Threads"
          >
            <i className="bi bi-threads me-2"></i>
            <span className="socialLinkText">Threads</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="https://www.etsy.com/shop/thescripthive"
            target="_blank"
            rel="noopener noreferrer"
            title="Scripthive Store"
          >
            <i className="bi bi-cart-fill me-2"></i>
            <span className="socialLinkText">Store</span>
          </a>
        </Col>
        <Col xs="auto">
          <a
            href="mailto:support@scripthive.com"
            target="_blank"
            rel="noopener noreferrer"
            title="Contact Support"
          >
            <i className="bi bi-envelope-at-fill me-2"></i>
            <span className="socialLinkText">Support</span>
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default SocialLinks;
